import { store } from "common/store";
import addClientUseCase from "../../clients/services/addClientUseCase";
import { admin, db } from "../../common/config/Firebase";
import { pad } from "../../common/services/util";
import { saveTask } from "../api";
import BusEvent from "common/services/BusEvent";
import { findClientByDNI } from "clients/api";
import { saveClient } from "clients/api";
import sendRecepcionByEmailUseCase from "./sendRecepcionByEmailUseCase";

const collectionParams = db.collection('params')

const addTaskUseCase = async (task) => {
    const taskParamCollection = collectionParams.doc('task')

    const paramsData = await taskParamCollection.get()
    const { count } = paramsData.data()

    applyDefaultCreated(task, count);

    // NOTA2: si se crea una tarea con precio ya definido, se asume aceptación verbal
    // → va directamente a "Reparando" con el tick de presupuesto aceptado
    if (parseFloat(task.budget) > 0 && parseInt(task.state) === 0) {
        task.state = 5; // Reparando
        task.budgetAccept = 1;
        task.dateAccepted = Date.now();
    }

    const increment = admin.firestore.FieldValue.increment(1)
    await taskParamCollection.update({ count: increment })

    const isNewClient = !store.getState().tasks.clientSelected.id && task.dni
    const { dni, clientName, phone, mail } = task
    let clientIva = true
    if (isNewClient) {
        await addClientUseCase({ id: dni, name: clientName, phone, mail, numberTasks: 1 })
    } else if (dni) {
        const client = await findClientByDNI(dni)
        const clientToUpdate = client.data()
        clientIva = clientToUpdate.iva !== false
        clientToUpdate.numberTasks = (clientToUpdate.numberTasks || 0) + 1

        if (!clientToUpdate.mail && mail) {
            clientToUpdate.mail = mail
        }

        await saveClient(clientToUpdate)
    }

    if (task.iva === undefined || task.iva === '') {
        task.iva = clientIva
    }
    
    task.isNewClient = isNewClient;

    return saveTask(task).then(() => {
    // Notificamos la tarea creada
    BusEvent.publish(BusEvent.NEW_TASK, { ...task, isNewClient });

    // Enviar email de recepción
    sendRecepcionByEmailUseCase(task).catch(err =>
        console.error("❌ Error enviando email de recepción:", err)
    );
});
}

const applyDefaultCreated = (task, reference = 0) => {

    Object.keys(task).forEach(key => task[key] = task[key] !== undefined ? task[key] : '')

    const now = Date.now();

    if (task.dateEntry == null) {
        task.dateEntry = now;
    }
    if (task.dateEntrySign == null) {
        task.dateEntrySign = task.dateEntry;
    }
    if (task.state == null) {
        task.state = 0;
    }
    if (task.reference == null) {
        task.reference = pad(reference, 4);
    }
}

export default addTaskUseCase